/**
 * CASHDAP-3292: per-device "don't remember this device" opt-out for Auto Remember Me.
 *
 * Set when the consumer taps "Not on this device" on the first-time issuance toast. Checked by
 * `useMintPersistentSessionOnLogin` so an opted-out device never mints another remember-me session,
 * regardless of who logs in — the opt-out is deliberately DEVICE-scoped, not account-scoped, because
 * its purpose is "this browser is shared / not mine" (the account-scoped escape hatches are
 * "Not you?" and the account-modal log out, which end the session server-side).
 *
 * localStorage (not a cookie, not redux): it must survive logout, session expiry, and new checkout
 * sessions on this device, but never travel to the server or another device. Reads/writes are
 * wrapped so private-browsing modes or storage-disabled contexts degrade to "not opted out" without
 * throwing, and guarded for SSR where `window` is undefined.
 */
const OPT_OUT_STORAGE_KEY = 'ap-remember-me-opt-out'

export const hasOptedOutRememberMe = (): boolean => {
  try {
    if (typeof window === 'undefined') {
      return false
    }
    return window.localStorage.getItem(OPT_OUT_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const setOptedOutRememberMe = (): void => {
  try {
    if (typeof window === 'undefined') {
      return
    }
    window.localStorage.setItem(OPT_OUT_STORAGE_KEY, 'true')
  } catch {
    // Best-effort: storage unavailable (private mode / disabled). The mint-skip simply won't
    // persist on this device; the consumer can opt out again on the next issuance toast.
  }
}
